import { Grid, Box, Typography, CircularProgress } from '@material-ui/core'
import React from 'react'

function BusinessChart (props) {
  const {  data, loading, error, title } = props  

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">{title}</Typography>
      </Grid>
      { loading && (
        <Grid item xs={12}>
          <Box width="100%" textAlign="center">
            <CircularProgress/>
          </Box>
        </Grid>
      )}
      { error && (
        <Grid item xs={12}>
          <Box width="100%" textAlign="center">
            <Typography>Error: {error.message}</Typography>
          </Box>
        </Grid>
      )}
      { !loading && !error && (
        <Grid item xs={12}>
          <Typography
            variant="h6"
            color="primary">
              Empty Givecard Business : {data[0].empty_gc_biz}
          </Typography>
          <Typography
            variant="h6"
            color="primary">
              Total Business : {data[0].total_biz}
          </Typography>
        </Grid>
      )}
    </Grid>
  )
}

export default BusinessChart
